import { css } from 'lit-element';
const style = css`
.options-filter-container {
  padding: 0 8px 8px 8px;
  overflow-y: auto;
}

.filter-container {
  display: flex;
  flex-direction: column;
  max-height: 170px;
  margin-bottom: 16px;
  background-color: var(--fc-color-surface-secondary);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

forter-checkbox[filtered] {
  opacity: 0;
  height: 0;
  pointer-events: none;
  position: absolute;
}

forter-checkbox {
  width: 100%;
  transition: opacity 0s;
  margin-top: var(--fc-spacing-xs);
  margin-bottom: var(--fc-spacing-xs);
}

forter-checkbox p {
  margin: 0;
  word-break: break-word;
  max-width: 100%;
  overflow: auto;
  white-space: normal;
}

.search-input {
  width: 100%;
}

:host > div:first-of-type {
  width: 100%;
  padding: 10px 8px;
  background-color: var(--fc-color-surface-secondary);
  border-top-left-radius: 10px;
  box-sizing: border-box;
  border-top-right-radius: 10px;
}
`;

export default style;

